import React, { useState } from 'react'
import Icons from '~/Common-Objects/UI/Icons/index'
import copy from 'copy-to-clipboard'
import { alterSnackbar } from '~/data/actions/siteActions'
import { useDispatch } from 'react-redux'
import { Tooltip } from 'react-tooltip'

export default function CopyPasteIcon({
    value,
    showOnHover = false,
    postHogTag = null,
    toolTipId = 'copy-paste-icon-tooltip'
}) {
    const dispatch = useDispatch()
    const [copied, setCopied] = useState(false)
    const copyVal = () => {
        copy(value)
        dispatch(alterSnackbar(true, 'Copied to clipboard'))
        setCopied(true)
    }

    const icon = showOnHover ? 'copyClipboardOutline' : 'copyClipboard'
    return (
        <>
            <Icons
                icon={icon}
                showOnHover={showOnHover}
                postHogTag={postHogTag}
                data-tooltip-id={toolTipId}
                color='var(--neutral-600)'
                style={{ height: 18, width: 18 }}
                onClick={() => {
                    copyVal()
                }}
                outerStyle={{
                    display: 'flex',
                    alignItems: 'center',
                    // The icon sits over the end of the URL, so give it a background
                    // to keep it readable against the text behind it.
                    backgroundColor: 'var(--neutral-0)',
                    boxShadow: '-8px 0 8px 0 var(--neutral-0)'
                }}
            />
            <Tooltip id={toolTipId} content={copied ? 'Copied!' : value} />
        </>
    )
}
